import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from './api/api'
import 'vant/lib/icon/local.css'

Vue.config.productionTip = false
Vue.prototype.$api = api
Vue.prototype.$imgUrl = window.g.env === 'test' ? window.g.devPublicUrl : window.g.prodPublicUrl
Vue.prototype.$aibusUrl = window.g.aibusUrl

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
